/* Lafayette Consignment — shipping protection toggle (built 2026-10-13)
   Adds / removes / re-bands the hidden "shipping-protection" product via /cart/update.js,
   then re-renders the cart drawer or cart page sections the same way Dawn does. */
(function () {
  if (customElements.get('laf-protection')) return;
  let busy = false;

  class LafProtection extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.laf-sp__input');
      this.errorEl = this.querySelector('.laf-sp__error');
      if (this.input) this.input.addEventListener('change', () => this.onToggle());
      this.reconcile();
    }

    get inCart() { return this.dataset.inCart === 'true'; }
    get current() { return parseInt(this.dataset.currentVariant || '0', 10); }
    get needed() { return parseInt(this.dataset.neededVariant || '0', 10); }

    /* Cart changed under us: wrong band in the cart, or protection left alone in the cart. */
    reconcile() {
      if (!this.inCart || busy) return;
      if (this.needed === 0 || this.current !== this.needed) {
        const now = Date.now();
        window.__lafSp = window.__lafSp || { n: 0, t: now };
        if (now - window.__lafSp.t > 10000) window.__lafSp = { n: 0, t: now };
        if (++window.__lafSp.n > 3) { console.warn('[laf-protection] reconcile loop guard'); return; }
        const updates = {};
        updates[this.current] = 0;
        if (this.needed !== 0) updates[this.needed] = 1;
        this.update(updates);
      }
    }

    onToggle() {
      const updates = {};
      if (this.input.checked) {
        if (this.inCart && this.current !== this.needed) updates[this.current] = 0;
        updates[this.needed] = 1;
      } else {
        updates[this.current || this.needed] = 0;
      }
      this.update(updates);
    }

    sectionsToRender() {
      const inDrawer = !!this.closest('cart-drawer');
      const list = [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
      if (inDrawer) {
        list.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
      } else {
        const items = document.getElementById('main-cart-items');
        const footer = document.getElementById('main-cart-footer');
        if (items) list.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
        if (footer) list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
      }
      return list;
    }

    update(updates) {
      if (busy) return;
      busy = true;
      this.classList.add('is-loading');
      if (this.errorEl) this.errorEl.hidden = true;
      const sections = this.sectionsToRender();
      const body = JSON.stringify({
        updates: updates,
        sections: sections.map((s) => s.section),
        sections_url: window.location.pathname,
      });
      const cfg = typeof fetchConfig === 'function' ? fetchConfig() : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      };
      fetch(window.routes && routes.cart_update_url ? routes.cart_update_url : '/cart/update.js', { ...cfg, body })
        .then((r) => r.json())
        .then((state) => {
          if (state.errors || state.status) throw new Error(state.errors || state.message || 'Cart update failed');
          const empty = state.item_count === 0;
          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.toggle('is-empty', empty);
          const drawerItems = document.querySelector('cart-drawer-items');
          if (drawerItems) drawerItems.classList.toggle('is-empty', empty);
          const pageItems = document.querySelector('cart-items');
          if (pageItems) pageItems.classList.toggle('is-empty', empty);
          const pageFooter = document.getElementById('main-cart-footer');
          if (pageFooter) pageFooter.classList.toggle('is-empty', empty);
          sections.forEach((s) => {
            const html = state.sections && state.sections[s.section];
            const host = document.getElementById(s.id);
            if (!html || !host) return;
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
            const target = host.querySelector(s.selector) || host;
            if (fresh) target.innerHTML = fresh.innerHTML;
          });
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'laf-protection', cartData: state });
          }
        })
        .catch((e) => {
          console.error('[laf-protection]', e);
          if (this.input) this.input.checked = this.inCart;
          if (this.errorEl) {
            this.errorEl.textContent = "Couldn't update shipping protection. Please try again.";
            this.errorEl.hidden = false;
          }
        })
        .finally(() => {
          busy = false;
          this.classList.remove('is-loading');
        });
    }
  }

  customElements.define('laf-protection', LafProtection);
})();
